import { render, staticRenderFns } from "./TravelRegistrations.vue?vue&type=template&id=ee4af1b8&scoped=true"
import script from "./TravelRegistrations.vue?vue&type=script&lang=js"
export * from "./TravelRegistrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4af1b8",
  null
  
)

export default component.exports